import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { makeStyles } from "@mui/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ShowImg(props) {
  const { dispatch, showImg } = props;
  const classes = makeStyle();

  return (
    <Dialog
      open={showImg?.open}
      TransitionComponent={Transition}
      maxWidth={"xs"}
      keepMounted
      onClose={() => dispatch("closeShowImg")}
      aria-describedby="alert-dialog-slide-description"
      className={classes.dialog}
    >
      <DialogContent style={{ padding: "20px 0" }}>
        <div className={classes.divContent}>
          <ArrowBackIosIcon
            size="small"
            className={classes.icon}
            onClick={() => dispatch({ type: "changeIndexImg", name: "pre" })}
          />
          <div className={classes.divImg}>
            <img style={{ width: "100%" }} src={showImg?.url} alt="imgs" />
            <CancelOutlinedIcon
              className="icon"
              onClick={() => dispatch("closeShowImg")}
            />
          </div>
          <ArrowForwardIosIcon
            size="small"
            className={classes.icon}
            onClick={() => dispatch({ type: "changeIndexImg", name: "next" })}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

const makeStyle = makeStyles(() => ({
  dialog: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      borderRadius: "12px",
    },
  },

  divContent: {
    display: "flex",
    alignItems: "center",
    position: "relative",
  },

  divImg: {
    width: "100%",
    maxWidth: "380px",

    "& .icon": {
      position: "absolute",
      top: "-20px",
      right: "1px",
    },
  },

  icon: { color: "#969696" },
}));
